import { define } from 'wicked-elements'
import onIntersect from '../lib/on-intersect.js'
import store from '../store'

/**
 * Fires active-section event to the bus
 * when a section enters/exits the viewport,
 * depending on if scrolling up or down.
 * Functionality is enabled/disabled based on
 * viewport size (data-above/below)
 */

define('[data-component~="sections"]', {
  init () {
    this.state = {
      scrollDirection: 'DOWN',
      lastScrollY: 0,
      hasFired: null,
      active: null,
      enabled: true
    }

    this.sections = [...this.element.querySelectorAll('[data-section]')]
    this.onEnter = this.onEnter.bind(this)
    this.onExit = this.onExit.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.resizeTimer = null
    this.observers = []
    this.enable()
  },
  connected () {
    this.addObservers()
    // rebuild observers on resize to recalculate center
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
  },
  disconnected () {
    this.removeObservers()
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
  },
  addObservers () {
    const verticalCenter = (window.innerHeight / -2) + 10
    this.sections.forEach(section => {
      this.observers.push({
        stopObserving: onIntersect(section, {
          rootMargin: `${verticalCenter}px 0px 0px 0px`
        }, this.onEnter, this.onExit)
      })
    })
  },
  removeObservers () {
    this.observers.forEach(observer => observer.stopObserving())
    this.observers = []
  },
  enable () {
    if (this.element.dataset.above) {
      this.state.enabled = window.innerWidth >= this.element.dataset.above
    } else if (this.element.dataset.below) {
      this.state.enabled = window.innerWidth < this.element.dataset.below
    }
  },
  handleResize () {
    clearTimeout(this.resizeTimer)
    this.resizeTimer = setTimeout(() => {
      this.removeObservers()
      this.addObservers()
    }, 250)
    this.enable()
  },
  onEnter (e) {
    this.setScrollDirection()
    if (!this.state.hasFired) {
      this.state.hasFired = true
      this.state.active = e.target.getAttribute('data-section')
      this.hydrate(this.state.active)
    } else if (this.state.scrollDirection === 'UP') {
      this.state.active = e.target.getAttribute('data-section')
      this.hydrate(this.state.active)
    }
  },
  onExit (e) {
    this.setScrollDirection()
    if (!this.state.hasFired) {
      this.state.hasFired = true
      this.state.active = e.target.getAttribute('data-section')
      this.hydrate(this.state.active)
    } else if (this.state.scrollDirection === 'DOWN') {
      let index = this.sections.findIndex(element => element.getAttribute('data-section') === e.target.getAttribute('data-section'))
      let nextElement = this.sections[index + 1]
      if (nextElement) {
        this.state.active = nextElement.getAttribute('data-section')
      } else {
        this.state.active = null
      }
      this.hydrate(this.state.active)
    }
  },
  hydrate (active) {
    // only hydrate when component is active and scrolling is triggered by user
    if (this.state.enabled && !store.state.programmaticScroll) {
      store.hydrate({ active: active })()
    }
  },
  setScrollDirection () {
    const myScrollTop = window.innerWidth < 960 ? window.scrollY : this.element.scrollTop
    this.state.scrollDirection = myScrollTop === this.state.lastScrollY 
      ? this.state.scrollDirection 
      : (myScrollTop > this.state.lastScrollY ? 'DOWN' : 'UP')
    this.state.lastScrollY = myScrollTop
    store.hydrate({ scrollDirection: this.state.scrollDirection })
  }
})